<template>
    <span v-if="typeServer" class="dev_pan">
      {{ typeServer }} | {{ appVersion }}
    </span>
</template>
  
<script>
export default {
  data() {
    return {
      baseBackendUrl: process.env.VUE_APP_BASE_URL,
      appVersion: "",
    }
  },
  computed: {
    typeServer() {
      if (this.baseBackendUrl === "https://pre.adsquiz.io") {
        return "DEV Server"
      } else if (this.baseBackendUrl === "https://api.quizads.tech") {
        return "Stage"
      } else if (this.baseBackendUrl === "https://api.quiz-app.org") {
        return "QA"
      } else if (this.baseBackendUrl === "https://api.quiz-demo.app") {
        return "DEMO Prod"
      } else {
        return null
      }
    },
  },
  methods: {
    getVersionFromLocalStorage() {
      this.appVersion = (localStorage.getItem('app_version'));
    },
  },
  mounted() {
    this.getVersionFromLocalStorage();
  }
}
</script>
  
<style scoped>
  .dev_pan {
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: black;
    color: chartreuse;
    font-weight: 700;
    padding: 3px;
    z-index: 9999;
  }
</style>
  